<template>
  <div class="modal-card">

    <header class="modal-card-head">
      <p class="modal-card-title">{{title}}</p>
    </header>

    <section class="modal-card-body">
      <slot />
    </section>

  </div>
</template>

<script>
export default {
  name: 'ModalWrapper',
  props: {
    title: String,
  },
};
</script>

<style>
.modal-close::before, .modal-close::after {
  background-color: #363636;
}
</style>
